import { useContext } from "react"
import { Button, Input, Typography, Form, Space } from "antd"
import { LoadingOutlined, LockOutlined, UserOutlined } from "@ant-design/icons"
import { useActor } from "@xstate/react"
// import { useSearchParams } from "react-router-dom"
import styled from "styled-components"

import { GlobalStateContext } from ".."
import { Centered, Colors, Spaces } from "../components/global"
import logo from "../assets/logo.svg"
// import { Selector, SelectorOption } from "../components/Designer/AccessPermissions/AccessPermissionForm"

const { Title, Paragraph } = Typography

export default function AuthPage() {
    const globalServices = useContext(GlobalStateContext)
    const [state, send] = useActor(globalServices.authService)

    // const [URLParams, setURLParams] = useSearchParams()
    // if (URLParams.get("mode") === "sign-up" && state.matches("authPage.logInForm")) send("SWITCH_AUTH")

    return (
        <Mask>
            <img src={logo} alt="quorini-logo" />

            <Title level={2} style={{ paddingTop: "0px", paddingBottom: "40px" }}>
                Build and run serverless cloud APIs
            </Title>

            {state.matches("checkAuth") && (
                <Centered vertical>
                    <LoadingOutlined style={{ fontSize: "65px", color: Colors.primary }} />
                    <Title level={3}>Checking user authentication...</Title>
                </Centered>
            )}

            {["authPage.logInForm", "authPage.signUpForm", "authPage.loggingIn", "authPage.signingUp"].some(state.matches) && (
                <FloatingCenterBlock>
                    {/* <Selector
                        onClick={() => {
                            send("SWITCH_AUTH")
                            URLParams.delete("mode")
                            setURLParams(URLParams)
                        }}
                    >
                        <SelectorOption selected={["authPage.logInForm", "authPage.loggingIn"].some(state.matches)}>
                            <UserOutlined /> Log in
                        </SelectorOption>
                        <SelectorOption selected={["authPage.signUpForm", "authPage.signingUp"].some(state.matches)}>
                            <KeyOutlined /> Sign up
                        </SelectorOption>
                    </Selector> */}

                    <Form
                        labelCol={{ span: 0 }}
                        wrapperCol={{ span: 24 }}
                        labelWrap={true}
                        colon={false}
                        layout="horizontal"
                        scrollToFirstError
                        name="signup"
                        style={{ width: "350px" }}
                        onFinish={() => {
                            if (state.matches("authPage.logInForm")) {
                                send("LOG_IN")
                            } else {
                                send("SIGN_UP")
                            }
                        }}
                        autoComplete="off"
                    >
                        <Form.Item name="username" rules={[{ required: true, message: "Please input your email address!" }]}>
                            <Input
                                disabled={state.matches("authPage.loggingIn") || state.matches("authPage.signingUp")}
                                prefix={<UserOutlined className="site-form-item-icon" />}
                                placeholder="Email address..."
                                title="Email address..."
                                onChange={(e) => {
                                    send({ type: "SET_USERNAME", username: e.target.value })
                                }}
                                size="large"
                                autoFocus
                            />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input your password!",
                                },
                                {
                                    pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*\W).+$/,
                                    message: "Should contain at least 1 uppercase, 1 lowercase, 1 digit and 1 special charecter.",
                                },
                                {
                                    min: 8,
                                    message: "Should be at least 8 characters.",
                                },
                            ]}
                        >
                            <Input.Password
                                disabled={state.matches("authPage.loggingIn") || state.matches("authPage.signingUp")}
                                prefix={<LockOutlined className="site-form-item-icon" />}
                                placeholder="Password..."
                                title="Password..."
                                onChange={(e) => {
                                    send({ type: "SET_PASSWORD", password: e.target.value })
                                }}
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                            <Space style={{ float: "right" }}>
                                <Button
                                    type="text"
                                    disabled={state.matches("authPage.loggingIn") || state.matches("authPage.signingUp")}
                                    onClick={() => {
                                        send("TO_RESET_PASSWORD")
                                    }}
                                >
                                    Forgot password?
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={state.matches("authPage.loggingIn") || state.matches("authPage.signingUp")}
                                >
                                    {["authPage.logInForm", "authPage.loggingIn"].some(state.matches) ? "Log in" : "Sign up"}
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </FloatingCenterBlock>
            )}

            {["authPage.resendingEmail", "authPage.verifyingEmail", "authPage.confirmEmailForm"].some(state.matches) && (
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                    labelWrap={true}
                    colon={false}
                    layout="horizontal"
                    scrollToFirstError
                    name="confirm-email"
                    onFinish={() => {
                        send("VERIFY_EMAIL")
                    }}
                    autoComplete="off"
                    style={{ width: "350px", display: "flex", flexDirection: "column", alignItems: "center" }}
                >
                    <Paragraph style={{ margin: "5px auto 20px" }}>We sent you an email with the verification code.</Paragraph>
                    {/* <Paragraph style={{ margin: "5px auto 20px" }}>Please check your inbox (or spam in case you haven’t received it)</Paragraph> */}
                    <Form.Item name="emailConfirmationCode" rules={[{ required: true, message: "Please input verification code!" }]}>
                        <Input
                            disabled={["authPage.resendingEmail", "authPage.verifyingEmail"].some(state.matches)}
                            placeholder="Verification code"
                            title="Verification code"
                            onChange={(e) => {
                                send({ type: "SET_VERIFICATION_CODE", emailConfirmationCode: e.target.value })
                            }}
                            size="large"
                            autoFocus
                        />
                    </Form.Item>

                    <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Space style={{ float: "right" }}>
                            <Button
                                type="text"
                                onClick={() => {
                                    send("RESEND_EMAIL")
                                }}
                                loading={state.matches("authPage.resendingEmail")}
                                disabled={state.matches("authPage.verifyingEmail")}
                                style={{ marginRight: "15px" }}
                            >
                                Resend email
                            </Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={state.matches("authPage.verifyingEmail")}
                                disabled={state.matches("authPage.resendingEmail")}
                            >
                                Confirm email
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            )}

            {["authPage.requestingResetPassword", "authPage.resetPasswordForm"].some(state.matches) && (
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                    labelWrap={true}
                    colon={false}
                    layout="horizontal"
                    scrollToFirstError
                    name="reset-password"
                    style={{ width: "350px" }}
                    onFinish={() => {
                        send("REQUEST_RESET_PASSWORD")
                    }}
                    autoComplete="off"
                >
                    <Form.Item name="username" rules={[{ required: true, message: "Please input your email address!" }]}>
                        <Input
                            disabled={state.matches("authPage.requestingResetPassword")}
                            prefix={<UserOutlined className="site-form-item-icon" />}
                            placeholder="Email address..."
                            title="Email address..."
                            onChange={(e) => {
                                send({ type: "SET_USERNAME", username: e.target.value })
                            }}
                            size="large"
                            autoFocus
                        />
                    </Form.Item>

                    <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Space style={{ float: "right" }}>
                            <Button type="primary" htmlType="submit" loading={state.matches("authPage.requestingResetPassword")}>
                                Reset password
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            )}

            {["authPage.confirmingResetPassword", "authPage.confirmResetForm"].some(state.matches) && (
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                    labelWrap={true}
                    colon={false}
                    layout="horizontal"
                    scrollToFirstError
                    name="confirm-reset-password"
                    style={{ width: "350px" }}
                    onFinish={() => {
                        send("CONFIRM_RESET_PASSWORD")
                    }}
                    autoComplete="off"
                >
                    <Form.Item name="resetPasswordConfirmationCode" rules={[{ required: true, message: "Please input verification code!" }]}>
                        <Input
                            disabled={state.matches("authPage.confirmingResetPassword")}
                            placeholder="Verification code"
                            title="Verification code"
                            onChange={(e) => {
                                send({ type: "SET_RESET_CODE", resetPasswordConfirmationCode: e.target.value })
                            }}
                            size="large"
                            autoFocus
                        />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: "Please input your password!",
                            },
                            {
                                pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*\W).+$/,
                                message: "Should contain at least 1 uppercase, 1 lowercase, 1 digit and 1 special charecter.",
                            },
                            {
                                min: 8,
                                message: "Should be at least 8 characters.",
                            },
                        ]}
                    >
                        <Input.Password
                            disabled={state.matches("authPage.confirmingResetPassword")}
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            placeholder="Password..."
                            title="Password..."
                            onChange={(e) => {
                                send({ type: "SET_PASSWORD", password: e.target.value })
                            }}
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Space style={{ float: "right" }}>
                            <Button type="primary" htmlType="submit" loading={state.matches("authPage.confirmingResetPassword")}>
                                Set new password
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            )}
        </Mask>
    )
}

export const Mask = styled.div`
    display: flex;
    width: 100vw;
    height: 100vh;
    background-color: ${Colors.background};
    flex-direction: column;
    align-items: center;
    padding-top: 150px;
`

const FloatingCenterBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${Spaces.xLarge};
    max-width: 350px;
`
